module.exports = __webpack_public_path__ + "img/DCIImg06.e1816227.png";